export const initiatePaymentEp = ()=>{
    return "/api/razorpay/initiate-payment"
}

export const verifyPaymentEp = ()=>{
    return '/api/razorpay/verify-payment'
}